import React from 'react';
import { func, string } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

// Import components
import { PaymentPacketsTemplate } from 'components/templates/payment';
import { Loader } from 'components/elements';
import Packets from 'components/views/payment/packets/Packets';

// Import styles
import { Wrapper, HeadingSecondStyled } from './styles';

// Import utilities
import { useUserAgent } from 'components/utilities';
import PacketsMobile from './PacketsMobile';

const PacketsModal = ({ toggle, uuid, subtype }) => {
	const { isMobile } = useUserAgent();
	const { loading, data: packets } = useSelector(
		({ product_packets }) => product_packets
	);

	const { t } = useTranslation();

	const isPacketsAvailable = packets && packets.length > 0;

	React.useEffect(() => {
		window.scroll({
			top: 0,
			behavior: 'smooth'
		});
	}, []);

	const renderPackets = () =>
		isMobile ? (
			<PacketsMobile vodSubtype={subtype} />
		) : (
			<Packets vodSubtype={subtype} />
		);

	return (
		<PaymentPacketsTemplate toggle={toggle} uuid={uuid}>
			<Wrapper isPacketsAvailable={isPacketsAvailable}>
				{loading ? (
					<Loader zIndex={900} background={false} />
				) : isPacketsAvailable ? (
					renderPackets()
				) : (
					<HeadingSecondStyled>
						{t(`packets_slider_${subtype}_packets_not_available`)}
					</HeadingSecondStyled>
				)}
			</Wrapper>
		</PaymentPacketsTemplate>
	);
};

PacketsModal.propTypes = {
	toggle: func.isRequired,
	uuid: string.isRequired,
	subtype: string.isRequired
};

export default PacketsModal;
